<div class="modal modal--in modal--close-{{ closePosition }}" [ngClass]="{ 'modal--out': modalAnimationOut }">
  <div class="modal__content modal__content--{{ size }}">
    <button class="modal__close" type="button" (click)="close()">
      <app-icon [icon]="'close'" [width]="24" [height]="24"></app-icon>
    </button>
    <ng-content></ng-content>
    @if (data) {
      <app-modal-generator [content]="data"></app-modal-generator>
    }
  </div>
</div>
